/** @jsxImportSource @emotion/react */

import { FC, ReactNode, useState } from "react";
import { ColorNames } from "../../theme";
import Icon from "../Icons";
import { IconNames } from "../Icons/styles/iconNames";
import { IconSizes } from "../Icons/styles/iconSizes";
import Row from "../Grid/Row";
import Column from "../Grid/Column";
import { css } from "@emotion/react";
import useIsMobile from "../../hooks/useIsMobile";

interface MobileGridProps {
  columns: ReactNode[];
}

const styles = {
  controllers: {
    position: "absolute" as const,
    zIndex: 10,
    "& span": {
      opacity: 0.7,
    },
  },
  controlerLeft: {
    left: 0,
  },
  controlerRight: {
    right: 0,
  },
  column: {
    height: "100%",
    width: "100%",
  },
};

const MobileGrid: FC<MobileGridProps> = ({ columns }) => {
  const [visibleColumnIndex, setVisibleColumnIndex] = useState<number>(0);

  const handleNextColumn = () => {
    if (visibleColumnIndex === columns.length - 1) {
      setVisibleColumnIndex(0);
    } else {
      setVisibleColumnIndex(visibleColumnIndex + 1);
    }
  };
  const handlePreviousColumn = () => {
    if (visibleColumnIndex === 0) {
      setVisibleColumnIndex(columns.length - 1);
    } else {
      setVisibleColumnIndex(visibleColumnIndex - 1);
    }
  };
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <>
      <>
        <div css={css(styles.controllers, styles.controlerLeft)}>
          <Icon
            name={IconNames.SkipBack}
            size={IconSizes.Large}
            color={ColorNames.GREY}
            onClick={handlePreviousColumn}
          />
        </div>
        <div css={css(styles.controllers, styles.controlerRight)}>
          <Icon
            name={IconNames.SkipForward}
            size={IconSizes.Large}
            color={ColorNames.GREY}
            onClick={handleNextColumn}
          />
        </div>
      </>
      <Row justify="center" css={styles.column} noGutters>
        <Column xs={12}>{columns[visibleColumnIndex]}</Column>
      </Row>
    </>
  );
};

export default MobileGrid;
